import { Message } from '@weblite/ts-action/message'
import { ReactElement } from 'react'
import { getUserFirstName, useUser } from '$logic/users'
import { SenderName } from '$common/chat-list-item-new/components/sender-name'
import { useWapp } from '$logic/wapps/react-hook'

function UserFirstNameGetter({ userId }: { userId: string }) {
  const { user } = useUser(userId)
  return <SenderName name={getUserFirstName(user)} />
}

function SenderWappNameGetter({ wappId }: { wappId: string }) {
  const { entity: wapp } = useWapp(wappId)
  return <SenderName name={wapp?.name || ''} />
}

export function LastMessageSenderName({
  lastMessage,
}: {
  lastMessage?: {
    sender: Message['sender']
    type: Omit<Message['type'], 'EVENT'>
  }
}): ReactElement | null {
  if (!lastMessage || lastMessage.type === 'EVENT') return null

  return lastMessage.sender.type === 'USER' ? (
    <UserFirstNameGetter userId={lastMessage.sender.id} />
  ) : lastMessage.sender.type === 'WAPP' ? (
    <SenderWappNameGetter wappId={lastMessage.sender.id} />
  ) : null
}
